
import Information from "../../../assets/filled/Information.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function InformationIcon({ className, dataTestid = "InformationIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Information data-testid={dataTestid} className={classes} {...rest} />
  );
}
